/* eslint-disable max-len */
/* This is a generated file. If you want to change it, edit generate-exports instead. */

import activity from '@jetbrains/icons/activity.svg';
import add10px from '@jetbrains/icons/add-10px.svg';
import add20px from '@jetbrains/icons/add-20px.svg';
import add from '@jetbrains/icons/add.svg';
import analytics from '@jetbrains/icons/analytics.svg';
import archive from '@jetbrains/icons/archive.svg';
import arrowUp from '@jetbrains/icons/arrow-up.svg';
import artifacts from '@jetbrains/icons/artifacts.svg';
import asterisk10px from '@jetbrains/icons/asterisk-10px.svg';
import asterisk from '@jetbrains/icons/asterisk.svg';
import attachment from '@jetbrains/icons/attachment.svg';
import average from '@jetbrains/icons/average.svg';
import bars from '@jetbrains/icons/bars.svg';
import bell from '@jetbrains/icons/bell.svg';
import branches from '@jetbrains/icons/branches.svg';
import bug from '@jetbrains/icons/bug.svg';
import buildType14pxArrow from '@jetbrains/icons/buildType-14px-arrow.svg';
import buildType14pxFillArrow from '@jetbrains/icons/buildType-14px-fill-arrow.svg';
import buildType14pxFill from '@jetbrains/icons/buildType-14px-fill.svg';
import buildType14px from '@jetbrains/icons/buildType-14px.svg';
import buildType20pxArrow from '@jetbrains/icons/buildType-20px-arrow.svg';
import buildType20pxFillArrow from '@jetbrains/icons/buildType-20px-fill-arrow.svg';
import buildType20pxFill from '@jetbrains/icons/buildType-20px-fill.svg';
import buildType20px from '@jetbrains/icons/buildType-20px.svg';
import buildTypeComposite14pxArrow from '@jetbrains/icons/buildType-composite-14px-arrow.svg';
import buildTypeComposite14pxFillArrow from '@jetbrains/icons/buildType-composite-14px-fill-arrow.svg';
import buildTypeComposite14pxFill from '@jetbrains/icons/buildType-composite-14px-fill.svg';
import buildTypeComposite14px from '@jetbrains/icons/buildType-composite-14px.svg';
import buildTypeComposite20pxArrow from '@jetbrains/icons/buildType-composite-20px-arrow.svg';
import buildTypeComposite20pxFillArrow from '@jetbrains/icons/buildType-composite-20px-fill-arrow.svg';
import buildTypeComposite20pxFill from '@jetbrains/icons/buildType-composite-20px-fill.svg';
import buildTypeComposite20px from '@jetbrains/icons/buildType-composite-20px.svg';
import burndown from '@jetbrains/icons/burndown.svg';
import calendar from '@jetbrains/icons/calendar.svg';
import cancel20px from '@jetbrains/icons/cancel-20px.svg';
import cancel from '@jetbrains/icons/cancel.svg';
import caretDown10px from '@jetbrains/icons/caret-down-10px.svg';
import caretRight10px from '@jetbrains/icons/caret-right-10px.svg';
import change from '@jetbrains/icons/change.svg';
import checkmark from '@jetbrains/icons/checkmark.svg';
import chevron10px from '@jetbrains/icons/chevron-10px.svg';
import chevronDown from '@jetbrains/icons/chevron-down.svg';
import chevronLeft from '@jetbrains/icons/chevron-left.svg';
import chevronRight from '@jetbrains/icons/chevron-right.svg';
import chevronUp from '@jetbrains/icons/chevron-up.svg';
import close from '@jetbrains/icons/close.svg';
import cloud from '@jetbrains/icons/cloud.svg';
import code from '@jetbrains/icons/code.svg';
import collapse from '@jetbrains/icons/collapse.svg';
import comment from '@jetbrains/icons/comment.svg';
import compare from '@jetbrains/icons/compare.svg';
import copy from '@jetbrains/icons/copy.svg';
import crop from '@jetbrains/icons/crop.svg';
import data from '@jetbrains/icons/data.svg';
import dice from '@jetbrains/icons/dice.svg';
import disconnected from '@jetbrains/icons/disconnected.svg';
import distribution from '@jetbrains/icons/distribution.svg';
import doubleChevronLeft from '@jetbrains/icons/double-chevron-left.svg';
import doubleChevronRight from '@jetbrains/icons/double-chevron-right.svg';
import download from '@jetbrains/icons/download.svg';
import drag from '@jetbrains/icons/drag.svg';
import drop from '@jetbrains/icons/drop.svg';
import eMail from '@jetbrains/icons/e-mail.svg';
import earth from '@jetbrains/icons/earth.svg';
import emoji from '@jetbrains/icons/emoji.svg';
import entry from '@jetbrains/icons/entry.svg';
import exception20px from '@jetbrains/icons/exception-20px.svg';
import exception from '@jetbrains/icons/exception.svg';
import expand from '@jetbrains/icons/expand.svg';
import experiment20px from '@jetbrains/icons/experiment-20px.svg';
import eye from '@jetbrains/icons/eye.svg';
import fields from '@jetbrains/icons/fields.svg';
import fileAddAny from '@jetbrains/icons/file-add-any.svg';
import fileArchive from '@jetbrains/icons/file-archive.svg';
import fileAs from '@jetbrains/icons/file-as.svg';
import fileAspectj from '@jetbrains/icons/file-aspectj.svg';
import fileConfig from '@jetbrains/icons/file-config.svg';
import fileCss from '@jetbrains/icons/file-css.svg';
import fileCustom from '@jetbrains/icons/file-custom.svg';
import fileDiagram from '@jetbrains/icons/file-diagram.svg';
import fileDtd from '@jetbrains/icons/file-dtd.svg';
import fileHtaccess from '@jetbrains/icons/file-htaccess.svg';
import fileHtml from '@jetbrains/icons/file-html.svg';
import fileIdl from '@jetbrains/icons/file-idl.svg';
import fileJavaClass from '@jetbrains/icons/file-java-class.svg';
import fileJavaOutsideSource from '@jetbrains/icons/file-java-outside-source.svg';
import fileJava from '@jetbrains/icons/file-java.svg';
import fileJs from '@jetbrains/icons/file-js.svg';
import fileJsonDark from '@jetbrains/icons/file-json-dark.svg';
import fileJsonSchemaDark from '@jetbrains/icons/file-json-schema-dark.svg';
import fileJsonSchema from '@jetbrains/icons/file-json-schema.svg';
import fileJson from '@jetbrains/icons/file-json.svg';
import fileJsp from '@jetbrains/icons/file-jsp.svg';
import fileJspx from '@jetbrains/icons/file-jspx.svg';
import fileManifest from '@jetbrains/icons/file-manifest.svg';
import fileProperties from '@jetbrains/icons/file-properties.svg';
import fileRegexp from '@jetbrains/icons/file-regexp.svg';
import fileText from '@jetbrains/icons/file-text.svg';
import fileUiForm from '@jetbrains/icons/file-ui-form.svg';
import fileUnknown from '@jetbrains/icons/file-unknown.svg';
import fileWsdl from '@jetbrains/icons/file-wsdl.svg';
import fileXhtml from '@jetbrains/icons/file-xhtml.svg';
import fileXml from '@jetbrains/icons/file-xml.svg';
import fileXsd from '@jetbrains/icons/file-xsd.svg';
import fileYaml from '@jetbrains/icons/file-yaml.svg';
import file from '@jetbrains/icons/file.svg';
import filters from '@jetbrains/icons/filters.svg';
import flag from '@jetbrains/icons/flag.svg';
import folder from '@jetbrains/icons/folder.svg';
import frown from '@jetbrains/icons/frown.svg';
import gift20px from '@jetbrains/icons/gift-20px.svg';
import gift from '@jetbrains/icons/gift.svg';
import git from '@jetbrains/icons/git.svg';
import group from '@jetbrains/icons/group.svg';
import help20px from '@jetbrains/icons/help-20px.svg';
import help from '@jetbrains/icons/help.svg';
import history from '@jetbrains/icons/history.svg';
import hourglass20px from '@jetbrains/icons/hourglass-20px.svg';
import hourglass from '@jetbrains/icons/hourglass.svg';
import ignored from '@jetbrains/icons/ignored.svg';
import info from '@jetbrains/icons/info.svg';
import investigation14px from '@jetbrains/icons/investigation-14px.svg';
import investigation from '@jetbrains/icons/investigation.svg';
import lamp from '@jetbrains/icons/lamp.svg';
import link from '@jetbrains/icons/link.svg';
import lock from '@jetbrains/icons/lock.svg';
import magicWand from '@jetbrains/icons/magic-wand.svg';
import mammoth20px from '@jetbrains/icons/mammoth-20px.svg';
import marker from '@jetbrains/icons/marker.svg';
import meta from '@jetbrains/icons/meta.svg';
import modified10px from '@jetbrains/icons/modified-10px.svg';
import moreOptions from '@jetbrains/icons/more-options.svg';
import moveToTop from '@jetbrains/icons/move-to-top.svg';
import move from '@jetbrains/icons/move.svg';
import mute from '@jetbrains/icons/mute.svg';
import muted from '@jetbrains/icons/muted.svg';
import newWindow from '@jetbrains/icons/new-window.svg';
import noArtifacts from '@jetbrains/icons/no-artifacts.svg';
import ok20px from '@jetbrains/icons/ok-20px.svg';
import ok from '@jetbrains/icons/ok.svg';
import overtime from '@jetbrains/icons/overtime.svg';
import paused14px from '@jetbrains/icons/paused-14px.svg';
import paused from '@jetbrains/icons/paused.svg';
import pencil from '@jetbrains/icons/pencil.svg';
import pennant from '@jetbrains/icons/pennant.svg';
import permission from '@jetbrains/icons/permission.svg';
import pinEmpty from '@jetbrains/icons/pin-empty.svg';
import pinFilled from '@jetbrains/icons/pin-filled.svg';
import play from '@jetbrains/icons/play.svg';
import prClose from '@jetbrains/icons/pr-close.svg';
import prMerged from '@jetbrains/icons/pr-merged.svg';
import prOpen from '@jetbrains/icons/pr-open.svg';
import prUnknown from '@jetbrains/icons/pr-unknown.svg';
import printer from '@jetbrains/icons/printer.svg';
import project14pxArrow from '@jetbrains/icons/project-14px-arrow.svg';
import project14pxFillArrow from '@jetbrains/icons/project-14px-fill-arrow.svg';
import project14pxFill from '@jetbrains/icons/project-14px-fill.svg';
import project14px from '@jetbrains/icons/project-14px.svg';
import project20pxArrow from '@jetbrains/icons/project-20px-arrow.svg';
import project20pxFillArrow from '@jetbrains/icons/project-20px-fill-arrow.svg';
import project20pxFill from '@jetbrains/icons/project-20px-fill.svg';
import project20px from '@jetbrains/icons/project-20px.svg';
import puzzle from '@jetbrains/icons/puzzle.svg';
import rate from '@jetbrains/icons/rate.svg';
import redo from '@jetbrains/icons/redo.svg';
import remove10px from '@jetbrains/icons/remove-10px.svg';
import renamed10px from '@jetbrains/icons/renamed-10px.svg';
import reviewersGraph from '@jetbrains/icons/reviewers-graph.svg';
import search20px from '@jetbrains/icons/search-20px.svg';
import searchEmpty from '@jetbrains/icons/search-empty.svg';
import searchError from '@jetbrains/icons/search-error.svg';
import search from '@jetbrains/icons/search.svg';
import services20px from '@jetbrains/icons/services-20px.svg';
import services from '@jetbrains/icons/services.svg';
import settings20px from '@jetbrains/icons/settings-20px.svg';
import settings from '@jetbrains/icons/settings.svg';
import shield from '@jetbrains/icons/shield.svg';
import spinner20px from '@jetbrains/icons/spinner-20px.svg';
import spinnerStatic from '@jetbrains/icons/spinner-static.svg';
import spinner from '@jetbrains/icons/spinner.svg';
import stamp from '@jetbrains/icons/stamp.svg';
import starEmpty14px from '@jetbrains/icons/star-empty-14px.svg';
import starEmpty from '@jetbrains/icons/star-empty.svg';
import starFilled14px from '@jetbrains/icons/star-filled-14px.svg';
import starFilled from '@jetbrains/icons/star-filled.svg';
import stop from '@jetbrains/icons/stop.svg';
import table from '@jetbrains/icons/table.svg';
import tag from '@jetbrains/icons/tag.svg';
import task from '@jetbrains/icons/task.svg';
import template14pxArrow from '@jetbrains/icons/template-14px-arrow.svg';
import template14px from '@jetbrains/icons/template-14px.svg';
import template20pxArrow from '@jetbrains/icons/template-20px-arrow.svg';
import template20px from '@jetbrains/icons/template-20px.svg';
import time from '@jetbrains/icons/time.svg';
import torrent from '@jetbrains/icons/torrent.svg';
import trash from '@jetbrains/icons/trash.svg';
import treemap from '@jetbrains/icons/treemap.svg';
import umbrella from '@jetbrains/icons/umbrella.svg';
import unauthorized from '@jetbrains/icons/unauthorized.svg';
import undo from '@jetbrains/icons/undo.svg';
import unknownOs from '@jetbrains/icons/unknown-os.svg';
import unsorted10px from '@jetbrains/icons/unsorted-10px.svg';
import update from '@jetbrains/icons/update.svg';
import user20px from '@jetbrains/icons/user-20px.svg';
import userCancel20px from '@jetbrains/icons/user-cancel-20px.svg';
import userCancel from '@jetbrains/icons/user-cancel.svg';
import userException20px from '@jetbrains/icons/user-exception-20px.svg';
import userException from '@jetbrains/icons/user-exception.svg';
import userGear from '@jetbrains/icons/user-gear.svg';
import userHourglass20px from '@jetbrains/icons/user-hourglass-20px.svg';
import userHourglass from '@jetbrains/icons/user-hourglass.svg';
import userOk20px from '@jetbrains/icons/user-ok-20px.svg';
import userOk from '@jetbrains/icons/user-ok.svg';
import userSpinner20px from '@jetbrains/icons/user-spinner-20px.svg';
import userSpinner from '@jetbrains/icons/user-spinner.svg';
import userWarning20px from '@jetbrains/icons/user-warning-20px.svg';
import userWarning from '@jetbrains/icons/user-warning.svg';
import user from '@jetbrains/icons/user.svg';
import vcsRoot14pxArrow from '@jetbrains/icons/vcs-root-14px-arrow.svg';
import vcsRoot14px from '@jetbrains/icons/vcs-root-14px.svg';
import vcsRoot20pxArrow from '@jetbrains/icons/vcs-root-20px-arrow.svg';
import vcsRoot20px from '@jetbrains/icons/vcs-root-20px.svg';
import voteEmpty from '@jetbrains/icons/vote-empty.svg';
import voteFilled from '@jetbrains/icons/vote-filled.svg';
import warning14px from '@jetbrains/icons/warning-14px.svg';
import warning20px from '@jetbrains/icons/warning-20px.svg';
import warning from '@jetbrains/icons/warning.svg';
import wrap from '@jetbrains/icons/wrap.svg';

import {iconHOC} from './icon';

export const ActivityIcon = iconHOC(activity, 'ActivityIcon');
export const Add10pxIcon = iconHOC(add10px, 'Add10pxIcon');
export const Add20pxIcon = iconHOC(add20px, 'Add20pxIcon');
export const AddIcon = iconHOC(add, 'AddIcon');
export const AnalyticsIcon = iconHOC(analytics, 'AnalyticsIcon');
export const ArchiveIcon = iconHOC(archive, 'ArchiveIcon');
export const ArrowUpIcon = iconHOC(arrowUp, 'ArrowUpIcon');
export const ArtifactsIcon = iconHOC(artifacts, 'ArtifactsIcon');
export const Asterisk10pxIcon = iconHOC(asterisk10px, 'Asterisk10pxIcon');
export const AsteriskIcon = iconHOC(asterisk, 'AsteriskIcon');
export const AttachmentIcon = iconHOC(attachment, 'AttachmentIcon');
export const AverageIcon = iconHOC(average, 'AverageIcon');
export const BarsIcon = iconHOC(bars, 'BarsIcon');
export const BellIcon = iconHOC(bell, 'BellIcon');
export const BranchesIcon = iconHOC(branches, 'BranchesIcon');
export const BugIcon = iconHOC(bug, 'BugIcon');
export const BuildType14pxArrowIcon = iconHOC(buildType14pxArrow, 'BuildType14pxArrowIcon');
export const BuildType14pxFillArrowIcon = iconHOC(buildType14pxFillArrow, 'BuildType14pxFillArrowIcon');
export const BuildType14pxFillIcon = iconHOC(buildType14pxFill, 'BuildType14pxFillIcon');
export const BuildType14pxIcon = iconHOC(buildType14px, 'BuildType14pxIcon');
export const BuildType20pxArrowIcon = iconHOC(buildType20pxArrow, 'BuildType20pxArrowIcon');
export const BuildType20pxFillArrowIcon = iconHOC(buildType20pxFillArrow, 'BuildType20pxFillArrowIcon');
export const BuildType20pxFillIcon = iconHOC(buildType20pxFill, 'BuildType20pxFillIcon');
export const BuildType20pxIcon = iconHOC(buildType20px, 'BuildType20pxIcon');
export const BuildTypeComposite14pxArrowIcon = iconHOC(buildTypeComposite14pxArrow, 'BuildTypeComposite14pxArrowIcon');
export const BuildTypeComposite14pxFillArrowIcon = iconHOC(buildTypeComposite14pxFillArrow, 'BuildTypeComposite14pxFillArrowIcon');
export const BuildTypeComposite14pxFillIcon = iconHOC(buildTypeComposite14pxFill, 'BuildTypeComposite14pxFillIcon');
export const BuildTypeComposite14pxIcon = iconHOC(buildTypeComposite14px, 'BuildTypeComposite14pxIcon');
export const BuildTypeComposite20pxArrowIcon = iconHOC(buildTypeComposite20pxArrow, 'BuildTypeComposite20pxArrowIcon');
export const BuildTypeComposite20pxFillArrowIcon = iconHOC(buildTypeComposite20pxFillArrow, 'BuildTypeComposite20pxFillArrowIcon');
export const BuildTypeComposite20pxFillIcon = iconHOC(buildTypeComposite20pxFill, 'BuildTypeComposite20pxFillIcon');
export const BuildTypeComposite20pxIcon = iconHOC(buildTypeComposite20px, 'BuildTypeComposite20pxIcon');
export const BurndownIcon = iconHOC(burndown, 'BurndownIcon');
export const CalendarIcon = iconHOC(calendar, 'CalendarIcon');
export const Cancel20pxIcon = iconHOC(cancel20px, 'Cancel20pxIcon');
export const CancelIcon = iconHOC(cancel, 'CancelIcon');
export const CaretDown10pxIcon = iconHOC(caretDown10px, 'CaretDown10pxIcon');
export const CaretRight10pxIcon = iconHOC(caretRight10px, 'CaretRight10pxIcon');
export const ChangeIcon = iconHOC(change, 'ChangeIcon');
export const CheckmarkIcon = iconHOC(checkmark, 'CheckmarkIcon');
export const Chevron10pxIcon = iconHOC(chevron10px, 'Chevron10pxIcon');
export const ChevronDownIcon = iconHOC(chevronDown, 'ChevronDownIcon');
export const ChevronLeftIcon = iconHOC(chevronLeft, 'ChevronLeftIcon');
export const ChevronRightIcon = iconHOC(chevronRight, 'ChevronRightIcon');
export const ChevronUpIcon = iconHOC(chevronUp, 'ChevronUpIcon');
export const CloseIcon = iconHOC(close, 'CloseIcon');
export const CloudIcon = iconHOC(cloud, 'CloudIcon');
export const CodeIcon = iconHOC(code, 'CodeIcon');
export const CollapseIcon = iconHOC(collapse, 'CollapseIcon');
export const CommentIcon = iconHOC(comment, 'CommentIcon');
export const CompareIcon = iconHOC(compare, 'CompareIcon');
export const CopyIcon = iconHOC(copy, 'CopyIcon');
export const CropIcon = iconHOC(crop, 'CropIcon');
export const DataIcon = iconHOC(data, 'DataIcon');
export const DiceIcon = iconHOC(dice, 'DiceIcon');
export const DisconnectedIcon = iconHOC(disconnected, 'DisconnectedIcon');
export const DistributionIcon = iconHOC(distribution, 'DistributionIcon');
export const DoubleChevronLeftIcon = iconHOC(doubleChevronLeft, 'DoubleChevronLeftIcon');
export const DoubleChevronRightIcon = iconHOC(doubleChevronRight, 'DoubleChevronRightIcon');
export const DownloadIcon = iconHOC(download, 'DownloadIcon');
export const DragIcon = iconHOC(drag, 'DragIcon');
export const DropIcon = iconHOC(drop, 'DropIcon');
export const EMailIcon = iconHOC(eMail, 'EMailIcon');
export const EarthIcon = iconHOC(earth, 'EarthIcon');
export const EmojiIcon = iconHOC(emoji, 'EmojiIcon');
export const EntryIcon = iconHOC(entry, 'EntryIcon');
export const Exception20pxIcon = iconHOC(exception20px, 'Exception20pxIcon');
export const ExceptionIcon = iconHOC(exception, 'ExceptionIcon');
export const ExpandIcon = iconHOC(expand, 'ExpandIcon');
export const Experiment20pxIcon = iconHOC(experiment20px, 'Experiment20pxIcon');
export const EyeIcon = iconHOC(eye, 'EyeIcon');
export const FieldsIcon = iconHOC(fields, 'FieldsIcon');
export const FileAddAnyIcon = iconHOC(fileAddAny, 'FileAddAnyIcon');
export const FileArchiveIcon = iconHOC(fileArchive, 'FileArchiveIcon');
export const FileAsIcon = iconHOC(fileAs, 'FileAsIcon');
export const FileAspectjIcon = iconHOC(fileAspectj, 'FileAspectjIcon');
export const FileConfigIcon = iconHOC(fileConfig, 'FileConfigIcon');
export const FileCssIcon = iconHOC(fileCss, 'FileCssIcon');
export const FileCustomIcon = iconHOC(fileCustom, 'FileCustomIcon');
export const FileDiagramIcon = iconHOC(fileDiagram, 'FileDiagramIcon');
export const FileDtdIcon = iconHOC(fileDtd, 'FileDtdIcon');
export const FileHtaccessIcon = iconHOC(fileHtaccess, 'FileHtaccessIcon');
export const FileHtmlIcon = iconHOC(fileHtml, 'FileHtmlIcon');
export const FileIdlIcon = iconHOC(fileIdl, 'FileIdlIcon');
export const FileJavaClassIcon = iconHOC(fileJavaClass, 'FileJavaClassIcon');
export const FileJavaOutsideSourceIcon = iconHOC(fileJavaOutsideSource, 'FileJavaOutsideSourceIcon');
export const FileJavaIcon = iconHOC(fileJava, 'FileJavaIcon');
export const FileJsIcon = iconHOC(fileJs, 'FileJsIcon');
export const FileJsonDarkIcon = iconHOC(fileJsonDark, 'FileJsonDarkIcon');
export const FileJsonSchemaDarkIcon = iconHOC(fileJsonSchemaDark, 'FileJsonSchemaDarkIcon');
export const FileJsonSchemaIcon = iconHOC(fileJsonSchema, 'FileJsonSchemaIcon');
export const FileJsonIcon = iconHOC(fileJson, 'FileJsonIcon');
export const FileJspIcon = iconHOC(fileJsp, 'FileJspIcon');
export const FileJspxIcon = iconHOC(fileJspx, 'FileJspxIcon');
export const FileManifestIcon = iconHOC(fileManifest, 'FileManifestIcon');
export const FilePropertiesIcon = iconHOC(fileProperties, 'FilePropertiesIcon');
export const FileRegexpIcon = iconHOC(fileRegexp, 'FileRegexpIcon');
export const FileTextIcon = iconHOC(fileText, 'FileTextIcon');
export const FileUiFormIcon = iconHOC(fileUiForm, 'FileUiFormIcon');
export const FileUnknownIcon = iconHOC(fileUnknown, 'FileUnknownIcon');
export const FileWsdlIcon = iconHOC(fileWsdl, 'FileWsdlIcon');
export const FileXhtmlIcon = iconHOC(fileXhtml, 'FileXhtmlIcon');
export const FileXmlIcon = iconHOC(fileXml, 'FileXmlIcon');
export const FileXsdIcon = iconHOC(fileXsd, 'FileXsdIcon');
export const FileYamlIcon = iconHOC(fileYaml, 'FileYamlIcon');
export const FileIcon = iconHOC(file, 'FileIcon');
export const FiltersIcon = iconHOC(filters, 'FiltersIcon');
export const FlagIcon = iconHOC(flag, 'FlagIcon');
export const FolderIcon = iconHOC(folder, 'FolderIcon');
export const FrownIcon = iconHOC(frown, 'FrownIcon');
export const Gift20pxIcon = iconHOC(gift20px, 'Gift20pxIcon');
export const GiftIcon = iconHOC(gift, 'GiftIcon');
export const GitIcon = iconHOC(git, 'GitIcon');
export const GroupIcon = iconHOC(group, 'GroupIcon');
export const Help20pxIcon = iconHOC(help20px, 'Help20pxIcon');
export const HelpIcon = iconHOC(help, 'HelpIcon');
export const HistoryIcon = iconHOC(history, 'HistoryIcon');
export const Hourglass20pxIcon = iconHOC(hourglass20px, 'Hourglass20pxIcon');
export const HourglassIcon = iconHOC(hourglass, 'HourglassIcon');
export const IgnoredIcon = iconHOC(ignored, 'IgnoredIcon');
export const InfoIcon = iconHOC(info, 'InfoIcon');
export const Investigation14pxIcon = iconHOC(investigation14px, 'Investigation14pxIcon');
export const InvestigationIcon = iconHOC(investigation, 'InvestigationIcon');
export const LampIcon = iconHOC(lamp, 'LampIcon');
export const LinkIcon = iconHOC(link, 'LinkIcon');
export const LockIcon = iconHOC(lock, 'LockIcon');
export const MagicWandIcon = iconHOC(magicWand, 'MagicWandIcon');
export const Mammoth20pxIcon = iconHOC(mammoth20px, 'Mammoth20pxIcon');
export const MarkerIcon = iconHOC(marker, 'MarkerIcon');
export const MetaIcon = iconHOC(meta, 'MetaIcon');
export const Modified10pxIcon = iconHOC(modified10px, 'Modified10pxIcon');
export const MoreOptionsIcon = iconHOC(moreOptions, 'MoreOptionsIcon');
export const MoveToTopIcon = iconHOC(moveToTop, 'MoveToTopIcon');
export const MoveIcon = iconHOC(move, 'MoveIcon');
export const MuteIcon = iconHOC(mute, 'MuteIcon');
export const MutedIcon = iconHOC(muted, 'MutedIcon');
export const NewWindowIcon = iconHOC(newWindow, 'NewWindowIcon');
export const NoArtifactsIcon = iconHOC(noArtifacts, 'NoArtifactsIcon');
export const Ok20pxIcon = iconHOC(ok20px, 'Ok20pxIcon');
export const OkIcon = iconHOC(ok, 'OkIcon');
export const OvertimeIcon = iconHOC(overtime, 'OvertimeIcon');
export const Paused14pxIcon = iconHOC(paused14px, 'Paused14pxIcon');
export const PausedIcon = iconHOC(paused, 'PausedIcon');
export const PencilIcon = iconHOC(pencil, 'PencilIcon');
export const PennantIcon = iconHOC(pennant, 'PennantIcon');
export const PermissionIcon = iconHOC(permission, 'PermissionIcon');
export const PinEmptyIcon = iconHOC(pinEmpty, 'PinEmptyIcon');
export const PinFilledIcon = iconHOC(pinFilled, 'PinFilledIcon');
export const PlayIcon = iconHOC(play, 'PlayIcon');
export const PrCloseIcon = iconHOC(prClose, 'PrCloseIcon');
export const PrMergedIcon = iconHOC(prMerged, 'PrMergedIcon');
export const PrOpenIcon = iconHOC(prOpen, 'PrOpenIcon');
export const PrUnknownIcon = iconHOC(prUnknown, 'PrUnknownIcon');
export const PrinterIcon = iconHOC(printer, 'PrinterIcon');
export const Project14pxArrowIcon = iconHOC(project14pxArrow, 'Project14pxArrowIcon');
export const Project14pxFillArrowIcon = iconHOC(project14pxFillArrow, 'Project14pxFillArrowIcon');
export const Project14pxFillIcon = iconHOC(project14pxFill, 'Project14pxFillIcon');
export const Project14pxIcon = iconHOC(project14px, 'Project14pxIcon');
export const Project20pxArrowIcon = iconHOC(project20pxArrow, 'Project20pxArrowIcon');
export const Project20pxFillArrowIcon = iconHOC(project20pxFillArrow, 'Project20pxFillArrowIcon');
export const Project20pxFillIcon = iconHOC(project20pxFill, 'Project20pxFillIcon');
export const Project20pxIcon = iconHOC(project20px, 'Project20pxIcon');
export const PuzzleIcon = iconHOC(puzzle, 'PuzzleIcon');
export const RateIcon = iconHOC(rate, 'RateIcon');
export const RedoIcon = iconHOC(redo, 'RedoIcon');
export const Remove10pxIcon = iconHOC(remove10px, 'Remove10pxIcon');
export const Renamed10pxIcon = iconHOC(renamed10px, 'Renamed10pxIcon');
export const ReviewersGraphIcon = iconHOC(reviewersGraph, 'ReviewersGraphIcon');
export const Search20pxIcon = iconHOC(search20px, 'Search20pxIcon');
export const SearchEmptyIcon = iconHOC(searchEmpty, 'SearchEmptyIcon');
export const SearchErrorIcon = iconHOC(searchError, 'SearchErrorIcon');
export const SearchIcon = iconHOC(search, 'SearchIcon');
export const Services20pxIcon = iconHOC(services20px, 'Services20pxIcon');
export const ServicesIcon = iconHOC(services, 'ServicesIcon');
export const Settings20pxIcon = iconHOC(settings20px, 'Settings20pxIcon');
export const SettingsIcon = iconHOC(settings, 'SettingsIcon');
export const ShieldIcon = iconHOC(shield, 'ShieldIcon');
export const Spinner20pxIcon = iconHOC(spinner20px, 'Spinner20pxIcon');
export const SpinnerStaticIcon = iconHOC(spinnerStatic, 'SpinnerStaticIcon');
export const SpinnerIcon = iconHOC(spinner, 'SpinnerIcon');
export const StampIcon = iconHOC(stamp, 'StampIcon');
export const StarEmpty14pxIcon = iconHOC(starEmpty14px, 'StarEmpty14pxIcon');
export const StarEmptyIcon = iconHOC(starEmpty, 'StarEmptyIcon');
export const StarFilled14pxIcon = iconHOC(starFilled14px, 'StarFilled14pxIcon');
export const StarFilledIcon = iconHOC(starFilled, 'StarFilledIcon');
export const StopIcon = iconHOC(stop, 'StopIcon');
export const TableIcon = iconHOC(table, 'TableIcon');
export const TagIcon = iconHOC(tag, 'TagIcon');
export const TaskIcon = iconHOC(task, 'TaskIcon');
export const Template14pxArrowIcon = iconHOC(template14pxArrow, 'Template14pxArrowIcon');
export const Template14pxIcon = iconHOC(template14px, 'Template14pxIcon');
export const Template20pxArrowIcon = iconHOC(template20pxArrow, 'Template20pxArrowIcon');
export const Template20pxIcon = iconHOC(template20px, 'Template20pxIcon');
export const TimeIcon = iconHOC(time, 'TimeIcon');
export const TorrentIcon = iconHOC(torrent, 'TorrentIcon');
export const TrashIcon = iconHOC(trash, 'TrashIcon');
export const TreemapIcon = iconHOC(treemap, 'TreemapIcon');
export const UmbrellaIcon = iconHOC(umbrella, 'UmbrellaIcon');
export const UnauthorizedIcon = iconHOC(unauthorized, 'UnauthorizedIcon');
export const UndoIcon = iconHOC(undo, 'UndoIcon');
export const UnknownOsIcon = iconHOC(unknownOs, 'UnknownOsIcon');
export const Unsorted10pxIcon = iconHOC(unsorted10px, 'Unsorted10pxIcon');
export const UpdateIcon = iconHOC(update, 'UpdateIcon');
export const User20pxIcon = iconHOC(user20px, 'User20pxIcon');
export const UserCancel20pxIcon = iconHOC(userCancel20px, 'UserCancel20pxIcon');
export const UserCancelIcon = iconHOC(userCancel, 'UserCancelIcon');
export const UserException20pxIcon = iconHOC(userException20px, 'UserException20pxIcon');
export const UserExceptionIcon = iconHOC(userException, 'UserExceptionIcon');
export const UserGearIcon = iconHOC(userGear, 'UserGearIcon');
export const UserHourglass20pxIcon = iconHOC(userHourglass20px, 'UserHourglass20pxIcon');
export const UserHourglassIcon = iconHOC(userHourglass, 'UserHourglassIcon');
export const UserOk20pxIcon = iconHOC(userOk20px, 'UserOk20pxIcon');
export const UserOkIcon = iconHOC(userOk, 'UserOkIcon');
export const UserSpinner20pxIcon = iconHOC(userSpinner20px, 'UserSpinner20pxIcon');
export const UserSpinnerIcon = iconHOC(userSpinner, 'UserSpinnerIcon');
export const UserWarning20pxIcon = iconHOC(userWarning20px, 'UserWarning20pxIcon');
export const UserWarningIcon = iconHOC(userWarning, 'UserWarningIcon');
export const UserIcon = iconHOC(user, 'UserIcon');
export const VcsRoot14pxArrowIcon = iconHOC(vcsRoot14pxArrow, 'VcsRoot14pxArrowIcon');
export const VcsRoot14pxIcon = iconHOC(vcsRoot14px, 'VcsRoot14pxIcon');
export const VcsRoot20pxArrowIcon = iconHOC(vcsRoot20pxArrow, 'VcsRoot20pxArrowIcon');
export const VcsRoot20pxIcon = iconHOC(vcsRoot20px, 'VcsRoot20pxIcon');
export const VoteEmptyIcon = iconHOC(voteEmpty, 'VoteEmptyIcon');
export const VoteFilledIcon = iconHOC(voteFilled, 'VoteFilledIcon');
export const Warning14pxIcon = iconHOC(warning14px, 'Warning14pxIcon');
export const Warning20pxIcon = iconHOC(warning20px, 'Warning20pxIcon');
export const WarningIcon = iconHOC(warning, 'WarningIcon');
export const WrapIcon = iconHOC(wrap, 'WrapIcon');
